import { Pipe, PipeTransform } from '@angular/core';
import { ContractAnalyticalFeatureEnum } from '@zaoblako/shared/modules/document/enums/contract-analytical-feature.enum';
import { ContractAnalyticalFeatureEnumI18n } from '@zaoblako/shared/modules/document/i18n/contract-analytical-feature-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

@Pipe({
  name: 'contractAnalyticalFeatureName',
  standalone: true
})
export class ContractAnalyticalFeatureNamePipe implements PipeTransform {
  public transform(name: ContractAnalyticalFeatureEnum): string {
    return ContractAnalyticalFeatureEnumI18n[I18nLocalesEnum.RU_RU][name] || name;
  }
}
